// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2ZtNg","form":"styles_form__QAGTV"};